import { reportsApi } from '../reports.api';
import { CreateFinalBalanceDto, PeriodDto } from '@sr/dto';

export type CashBalanceQuery = {
  year: number,
  month: number,
};

const cashBalanceApi = reportsApi.enhanceEndpoints({
  addTagTypes: ['cash-balance'],
}).injectEndpoints({
  endpoints: (builder) => ({
    getCashBalance: builder.query<any[], CashBalanceQuery>({
      query: ({ year, month }: CashBalanceQuery) => ({
        url: `cash-balance/${year}/${month}`,
      }),
      providesTags: (result, error, { year, month }) => result
        ? [{ type: 'cash-balance', id: `${year}-${month}` }]
        : ['cash-balance'],
    }),
    saveFinalBalance: builder.mutation<Omit<CreateFinalBalanceDto, 'createdById'>, Omit<CreateFinalBalanceDto, 'createdById'>>({
      query: (dto) => ({
        url: `cash-balance/save`,
        body: dto,
        method: 'POST',
      }),
      invalidatesTags: (result, error, dto) => result
        ? [{ type: 'cash-balance', id: `${dto.year}-${dto.month}` }]
        : ['cash-balance'],
    }),
    getCashBalancePeriods: builder.query<PeriodDto[], void>({
      query: () => ({
        url: 'cash-balance/periods',
        method: 'GET',
      }),
    }),
  }),
});

export { cashBalanceApi };